import { FETCH_POPUP_DATA, OPEN_DETAILS_POPUP, CLOSE_POPUP, SET_POPUP_PAGINATION, UPDATE_ALERT_STATUS_REQUEST_DATAGUARD } from './ActionTypes';

export const openDetailsPopup = (params, isChildLevel = false) => ({
  type: OPEN_DETAILS_POPUP,
  payload: { ...params, isChildLevel }
});

export const fetchPopupData = () => ({
  type: FETCH_POPUP_DATA
});

export const setPopupPagination = (pagination) => ({
  type: SET_POPUP_PAGINATION,
  payload: pagination
});

export const closePopup = () => ({
  type: CLOSE_POPUP
});

export const updateAlertStatus = (payload) => {
  return {
    type: UPDATE_ALERT_STATUS_REQUEST_DATAGUARD,
    payload: payload,
  };
};